/*
 * Post-register.ts
 * Description: Includes function for sending a request
 * to get a JWT and add user data in to the database,
 * hence, to register the user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL, EmailTaken} from '@/ts/variables';
// Importing interface
import {User} from '@/ts/auth/validate-register';

/**
 * Registering new users
 *
 * @param errors - list of errors
 * @param data - user data
 * @return {Object} Promise - whether logging registration has been successful
 */
export function postRegister(errors: string[], data: User) {
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'auth/register',
            method: 'post',
            data,
        }).then((response) => {
            const authData = response.data.data;
            // Construct an expiration date
            const date = new Date(new Date().getTime() + (1000 * authData.expires_in));
            // Construct local storage items
            localStorage.setItem('user', authData.user.first_name + ' ' + authData.user.last_name);
            localStorage.setItem('jwt', authData.access_token);
            localStorage.setItem('expireDate', String(date));
            resolve();
        }).catch((error) => {
            const err = error.response.data;
            // Checking if the field email exists in errors, to prevent errors.
            if (Array.isArray(err.errors.email)) {
                for (const temp of err.errors.email) {
                    if (temp === 'The email has already been taken.') {
                        errors.push(EmailTaken);
                    } else {
                        errors.push(temp);
                    }
                }
            }
            // Checking if the field password exists in errors, to prevent errors.
            if (Array.isArray(err.errors.password)) {
                for (const temp of err.errors.password) {
                    errors.push(temp);
                }
            }
            reject();
        });
    });
}
